import { makeStyles } from 'tss-react/mui';

import { dFlex, scrollBar } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  tabs: {
    display: 'flex',
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
    },

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gridTemplateColumns: '1fr',
    },
  },
  inner: {
    display: 'grid',
    gap: 8,
  },
  filterTabs: {
    '& .MuiButtonBase-root.MuiButton-root': {
      padding: '6px 14px',

      [theme.breakpoints.down(Breakpoint.Md)]: {
        minWidth: 'initial',
        width: 'auto',
        flexGrow: 1,
      },
    },
  },
  farmsTabs: {
    '& .MuiButtonBase-root.MuiButton-root': {
      padding: '6px 14px',

      [theme.breakpoints.down(Breakpoint.Md)]: {
        minWidth: 'initial',
        width: 'auto',
        flexGrow: 1,
      },
    },
  },
  V3farmsTabs: {
    '& .MuiButtonBase-root.MuiButton-root': {
      padding: '6px 14px',

      [theme.breakpoints.down(Breakpoint.Md)]: {
        minWidth: 'initial',
        width: 'auto',
        flexGrow: 1,
      },
    },
  },
  btnBox: {
    ...dFlex(),
    gap: 16,
    width: '100%',

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      marginTop: 'auto',
    },
  },
  btn: {
    [theme.breakpoints.down(Breakpoint.Md)]: {
      width: '100%',
      marginTop: 'auto',
    },
  },
  container: {
    ...dFlex('initial', 'initial'),
    gap: 16,
    flexDirection: 'column',

    overflowY: 'auto',
    ...scrollBar,

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      height: '100%',
    },
  },
  selectBox: {
    ...dFlex(),
    width: '100%',

    '> div': {
      flex: 1,
    },

    '.MuiFormControl-root': {
      borderRadius: `${theme.borderRadius.md} 0 0 ${theme.borderRadius.md}`,
      '.MuiInputBase-root': {
        borderRadius: `${theme.borderRadius.md} 0 0 ${theme.borderRadius.md}`,
      },
    },
  },
  selectSortButton: {
    '&.MuiButtonBase-root.MuiButton-root': {
      border: 0,

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '96%',
        background: theme.secondary.s2,
        left: 0,
      },
    },
  },
  innerSelects: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    width: '100%',
    gap: 8,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gridTemplateColumns: '1fr',
    },
  },
  tagList: {
    ...dFlex('start'),
    flexWrap: 'wrap',
    gap: 8,
  },
  selectedFilters: {
    ...dFlex('start'),
    flexWrap: 'wrap',
    gap: 8,
  },
  slider: {
    maxWidth: '94%',
    margin: '0 auto',
  },
  loaderBox: {
    ...dFlex(),
    minHeight: 634,
  },
  rangesBox: {
    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gridTemplateRows: 'auto',
      gridTemplateColumns: 'repeat(2, 1fr)',

      '& > :nth-of-type(5)': {
        gridColumn: 'span 2',
      },
    },
  },
  slidersBox: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gridTemplateColumns: '1fr',
    },
  },
  modal: {
    height: 'initial',
  },
}));

export default useStyles;
